import React from 'react';
import * as Render from '../platformui/Base/Render';
import HighLight from '../platformui/HighLight';
export default (props) => (
  <HighLight
    {...props}
    ContentString={Render.PropertyAsHTML(props.ContentString, 'Content')}
  />
);